import React from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import { Carousel } from 'react-bootstrap';

const CustomersItem = ({ name , charac , describe }) => {
    return (
        <>
            <h3>{name}</h3>
            <h4>{charac}</h4>
            <p>{describe}</p>
        </>
       
    )
}   


export default CustomersItem
